import {
  ComponentsOverrides,
  Interpolation,
  MenuItemProps,
  Theme,
} from '@mui/material';

export const MenuStyles: ComponentsOverrides<Theme>['MuiMenu'] =
  {
    paper: {
      borderRadius: '0.75rem',
      minWidth: '10rem',
    },
  };

export const MenuItemStyles: ComponentsOverrides<Theme>['MuiMenuItem'] =
  {
    root: {
      alignItems: 'center',
      minHeight: '2rem',
    },
  };

export const MenuItemVariants:
  {
    props: Partial<MenuItemProps>;
    style: Interpolation<{
      theme: Omit<Theme, 'components'>;
    }>;
  }[] | undefined = [
  {
    props: { color: 'error' },
    style: {
      color: '#BD002A',
    },
  },
];

export const MenuMenuListStyles: ComponentsOverrides<Theme>['MuiMenuList'] =
  {
    root: {
      padding: '0',
    },
  };

export const ListItemIconStyles: ComponentsOverrides<Theme>['MuiListItemIcon'] =
  {
    root: {
      //minWidth: 'initial !important',
    },
  };